// extracted by mini-css-extract-plugin
module.exports = {"container":"MainMenuItems_container__1lHsk","MenuItem":"MainMenuItems_MenuItem__26e6s","small":"MainMenuItems_small__27bbp"};